/* eslint-disable eqeqeq */
import { Button, Image, Input, Modal, Switch, Tabs, Tag, Tooltip, message } from 'antd'
import KrwPrice from 'app/components/PositionColumns/KrwPrice'
import { COLORS } from 'app/constants'
import { useToken, useWindowDimensions } from 'app/hooks'
import React, { useEffect } from 'react'
import { Text, View } from 'styles/reactnative'
import API from '../../../../utils/api'
import { FOOTER } from '../../../constants/SETTING'
import EntryTime from '../../PositionColumns/EntryTime'
import TableAPI from '../../TableAPI'
import { column_balance_daily_small } from './column_balance_daily_small'
import { column_closedpnl } from './column_closedpnl'
import { column_ip } from './column_ip'
import { column_log } from './column_log'
import { column_admin_log } from './column_admin_log'
import { column_order } from './column_order'
import { column_ovs_person } from './column_ovs_person'
import { column_position } from './column_position'
import { column_referral } from './column_referral'
import { column_sc } from './column_sc'
import { column_setting } from './column_setting'
import { column_wallet } from './column_wallet'
import { column_walletlist } from './column_walletlist'
import { TagWrap } from './styles'
import {
	TabsContainer,
	StyledTabs,
	TabHeader,
	FilterButton,
	SettingCard,
	SettingTitle,
	SettingContent,
	TableWrapper
} from './ModernStyles'

export const buttonlist = {
	PC사양: ['FR000'],
	주문접수: ['GT001', 'GT000'],
	주문체결: ['GT005'],
	주문취소: ['ST004', 'GT003', 'GT100'],
	로스컷: ['GT999'],
	'접속/연결': ['HM001', 'LOGINTRY', 'FR008', 'JOIN'],
	전체프론트: [
		'ST001',
		'ST002',
		'ST004',
		'ST005',
		'ST006',
		'ST007',
		'ST008',
		'ST009',
		'SO003',
		'GT006',
		'FR001',
		'FR002',
		'FR003',
		'FR004',
		'FR005',
		'FR006',
		'SO001',
		'FR008',
		'FR020',
		'FR021',
		'FR011',
		'FR012',
		'FR013',
	],
	'키/클릭': ['FR020', 'FR021'],
	MIT: ['MIT001', 'MIT002', 'MIT003'],
	손익절: ['ST005', 'ST007', 'FR005', 'ST006'],
	오버나잇: ['FR030', 'FR031', 'FR032', 'GT009'],
}

const UserInfoTabs = ({ data, fold }) => {
	const { width } = useWindowDimensions()
	const { data: token, userid: adminId, level: adminLevel } = useToken()
	
	// 환경변수에서 화면보기 기능 설정 가져오기
	const allowIds = (process.env.REACT_APP_ADMIN_ALLOW_IDS || '').split(',');
	const screenViewEnabled = process.env.REACT_APP_SCREEN_VIEW_ENABLED === 'true';

	const [lazy, setLazy] = React.useState(true)

	const [refresh, setRefresh] = React.useState(false)
	const [scdata, setScdata] = React.useState<any>(null)

	const [setting, setSetting] = React.useState('')

	const [logfilter, setLogfilter] = React.useState<any>('')

	const [log, setLog] = React.useState<any>(new Set([]))

	const [url, setUrl] = React.useState('')

	const [scRefresh, setScRefresh] = React.useState(0)
	const [fastMode, setFastMode] = React.useState(true) // 빠른 로딩 모드 (기본값: 활성화)

	useEffect(() => {
		setLazy(true)
	}, [])

	useEffect(() => {
		if (log.size == 0) {
			setLogfilter('')
		} else {
			const temp = Array.from(log)
				.map((key: any) => buttonlist[key])
				.flat()
			setLogfilter(temp.join(','))
		}
	}, [log])

	useEffect(() => {
		setScdata(null)
	}, [data])

	const handleDeleteAllScreenshots = () => {
		Modal.confirm({
			title: '전체 스크린샷 삭제',
			content: '이 회원의 모든 스크린샷을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
			okText: '삭제',
			okType: 'danger',
			cancelText: '취소',
			onOk: async () => {
				try {
					const response = await API.delete('/admin/scall', token + '', {
						userid: data?.id
					})

					if (response?.result?.success) {
						message.success('모든 스크린샷이 삭제되었습니다')
						setScRefresh(prev => prev + 1)
						setScdata(null)
					} else {
						message.error(response?.result?.message || '삭제 실패')
					}
				} catch (error) {
					console.error('Screenshot deletion error:', error)
					message.error('삭제 중 오류가 발생했습니다')
				}
			}
		})
	}

	const tabs = [
		{
			title: '활동',
			apikey:
				'/admin/history/users?log=' +
				logfilter +
				'&type=user_id&searchWord=',
			columns: column_log,
			detail:
				'/record/activity-history?log=' +
				logfilter +
				'&userid=' +
				data?.id,
			datesearch: true,
			header: (
				<TabHeader>
					<FilterButton
						$active={log.size == 0}
						$danger
						$first
						onClick={() => setLog(new Set([]))}>
						전체로그
					</FilterButton>
					<div style={{ display: 'inline-flex' }}>
						{buttonlist &&
							Object.keys(buttonlist)?.map((key, index) => (
								<FilterButton
									key={key}
									$active={log?.has(key)}
									onClick={() => {
										if (log?.has(key)) {
											setLog((prev: any) => {
												const temp = new Set(prev)
												temp.delete(key)
												return temp
											})
										} else {
											setLog((prev: any) => {
												const temp = new Set(prev)
												temp.add(key)
												return temp
											})
										}
									}}>
									{key}
								</FilterButton>
							))}
					</div>
				</TabHeader>
			),
		},
		{
			title: '화면',
			apikey: '/admin/sclist?refresh=' + scRefresh + (fastMode ? '&fast=1' : '') + '&userid=',
			datesearch: false,
			columns: column_sc,
		},
		{
			title: 'IP',
			apikey: '/admin/userip?userid=',
			columns: column_ip,
		},
		{
			title: '거래',
			apikey: '/admin/history/orders?type=user_id&searchWord=',
			columns: column_order,
			datesearch: true,
			detail: '/record/transaction-details?userid=' + data?.id,
		},
		{
			title: '실시간',
			apikey: '/admin/history/positions?user_id=',
			columns: column_position,
			detail: '/position/open?userid=' + data?.id,
			footer: FOOTER.MARGINSUM,
		},
		{
			title: '청산',
			apikey: '/admin/history/closedpnl?ep_id=*&user_id=',
			columns: column_closedpnl,
			datesearch: true,
			detail: '/position/closed?userid=' + data?.id,
		},
		{
			title: '일일정산',
			apikey: '/admin/dailybalance?order=daydate desc, id asc&userid=',
			columns: column_balance_daily_small,
			detail: '/balance/daily?userid=' + data?.id,
			footer: 1,
		},
		{
			title: '입출금',
			apikey: '/admin/user/cash?userid=',
			columns: AdminDepositTableColumn,
			datesearch: true,
			detail: '/cash/deposit?userid=' + data?.id,
		},
		{
			title: '현금내역',
			apikey: '/admin/history/wallet?userid=',
			columns: column_wallet,
			datesearch: true,
			walletlist: true,
			detail: '/record/wallet-history?userid=' + data?.id,
		},
		{
			title: '계좌',
			apikey: '/admin/walletlist?userid=',
			columns: column_walletlist,
		},
		{
			title: '추천인',
			apikey: '/admin/history/referral?type=user_id&searchWord=',
			columns: column_referral,
		},
		{
			title: '개인별계약',
			apikey: '/admin/exchangepairs?ov=1&userid=',
			columns: column_ovs_person,
		},
		{
			title: '설정',
			apikey:
				'/admin/user/setting?type=ALL&' +
				'refresh=' +
				(refresh ? 1 : 0) +
				'&' +
				'userid=',
			columns: column_setting,
		},
		{
			title: '관리자로그',
			apikey: '/admin/user/' + data?.id + '/logs?dummy=',
			columns: column_admin_log,
			datesearch: false,
		},
	]

	const ChildrenComp = id => {
		return (
			<>
				{tabs[id].title == '설정' && (
					<>
						<SettingCard>
							<SettingTitle>수익청산방지 시간 (0 이면 사용안함)</SettingTitle>
							<SettingContent>
								<input
									value={setting}
									onChange={e => setSetting(e.target.value)}
									placeholder="시간 입력"
								/>
								<button
									onClick={() => {
									API.post(
										'/admin/user/setting',
										token + '',
										{
											userid: data?.id,
											type: 1,
											key: 'PPT',
											value: setting,
										}
									).then(res => {
										if (res.result.success) {
											message.success('성공')
											setRefresh(!refresh)
										} else {
											message.error(
												res?.result?.message || '실패'
											)
										}
									})
								}}>
									설정추가
								</button>
							</SettingContent>
						</SettingCard>
						<SettingCard>
							<SettingTitle>보안프로그램 패스옵션</SettingTitle>
							<SettingContent>
								<button
									onClick={() => {
									API.post(
										'/admin/user/setting',
										token + '',
										{
											userid: data?.id,
											type: 1,
											key: 'SEC',
											value: '1',
										}
									).then(res => {
										if (res.result.success) {
											message.success('성공')
											setRefresh(!refresh)
										} else {
											message.error(
												res?.result?.message || '실패'
											)
										}
									})
								}}>
									보안프로그램패스
								</button>
							</SettingContent>
						</SettingCard>
						<SettingCard>
							<SettingTitle>파트너권한 (파트너등급만적용)</SettingTitle>
							<SettingContent>
								<button
									onClick={() => {
									API.post(
										'/admin/user/setting',
										token + '',
										{
											userid: data?.id,
											type: 1,
											key: 'PRT',
											value: '1',
										}
									).then(res => {
										if (res.result.success) {
											message.success('성공')
											setRefresh(!refresh)
										} else {
											message.error(
												res?.result?.message || '실패'
											)
										}
									})
								}}>
									화면보기권한
								</button>
								<button
									onClick={() => {
									API.post(
										'/admin/user/setting',
										token + '',
										{
											userid: data?.id,
											type: 1,
											key: 'PIP',
											value: '1',
										}
									).then(res => {
										if (res.result.success) {
											message.success('성공')
											setRefresh(!refresh)
										} else {
											message.error(
												res?.result?.message || '실패'
											)
										}
									})
								}}>
									IP조회권한
								</button>
								<button
									onClick={() => {
									API.post(
										'/admin/user/setting',
										token + '',
										{
											userid: data?.id,
											type: 1,
											key: 'PAT',
											value: '1',
										}
									).then(res => {
										if (res.result.success) {
											message.success('성공')
											setRefresh(!refresh)
										} else {
											message.error(
												res?.result?.message || '실패'
											)
										}
									})
								}}>
									활동로그조회
								</button>
								<button
									onClick={() => {
									API.post(
										'/admin/user/setting',
										token + '',
										{
											userid: data?.id,
											type: 1,
											key: 'PSL',
											value: '1',
										}
									).then(res => {
										if (res.result.success) {
											message.success('성공')
											setRefresh(!refresh)
										} else {
											message.error(
												res?.result?.message || '실패'
											)
										}
									})
								}}>
									슬리피지권한
								</button>
							</SettingContent>
						</SettingCard>
					</>
				)}

				{tabs[id].title == '화면' ? (
					<View
						style={{
							flexDirection: 'column',
							flex: 1,
							alignContent: 'flex-start',
							justifyContent: 'flex-start',
							alignItems: 'flex-start',
							background: '#cdcdcd',
							borderRadius: 5,
						}}>
						{/* 화면보기 기능이 비활성화되면 누구든 볼 수 있고, 활성화되면 특정 관리자만 볼 수 있음 */}
						{!screenViewEnabled || allowIds.includes(adminId.toString()) ? (
							<>
								{/* 로딩 모드 선택 + 전체삭제 버튼 */}
								<View
									style={{
										width: '100%',
										padding: '10px',
										backgroundColor: '#f5f5f5',
										borderBottom: '1px solid #d9d9d9',
										flexDirection: 'row',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}>
									<View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
										<Text style={{ fontSize: 12, color: '#666' }}>빠른로딩</Text>
										<Switch
											size="small"
											checked={fastMode}
											onChange={setFastMode}
										/>
										<Text style={{ fontSize: 11, color: '#999' }}>
											{fastMode ? '(전체 개수 미표시)' : '(느릴 수 있음)'}
										</Text>
									</View>
									{/* 권한 99 관리자 전용 전체삭제 버튼 */}
									{adminLevel === 99 && (
										<Button
											danger
											type="primary"
											size="small"
											onClick={handleDeleteAllScreenshots}>
											전체삭제
										</Button>
									)}
								</View>
								<View
									style={{
										flexDirection: 'row',
										flex: 1,
										alignContent: 'flex-start',
										justifyContent: 'flex-start',
										alignItems: 'flex-start',
										width: '100%',
									}}>
									<TableAPI
										title={tabs[id].title}
										stylewidth={260}
										width={220}
										apikey={tabs[id].apikey + data?.id}
										height={650}
										columns={tabs[id].columns}
										detail={tabs[id].detail}
										datesearch={tabs[id].datesearch}
										walletlist={tabs[id].walletlist}
										footer={tabs[id].footer}
										fold={fold}
										uid={data?.id}
										setSC={setScdata}
										loadMoreMode={fastMode}
									/>
									{scdata == null ? null : (
										<View
											style={{
												width: '100%',
												flex: 1,
												background: '#cdcdcd',
												alignContent: 'flex-start',
												alignItems: 'flex-start',
												justifyContent: 'flex-start',
											}}>
											<EntryTime time={scdata?.created_at} offset={0}/>
											<Image
												style={{ width: '100%', height: '100%' }}
												src={scdata?.url || scdata?.data}
											/>
										</View>
									)}
								</View>
							</>
						) : (
							<View
								style={{
									width: '100%',
									height: 650,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									background: '#f5f5f5',
									borderRadius: 5,
								}}>
								<Text
									style={{
										fontSize: 18,
										fontWeight: 'bold',
										color: '#666',
									}}>
									점검중입니다
								</Text>
								<Text
									style={{
										fontSize: 14,
										color: '#999',
										marginTop: 10,
									}}>
									현재 화면 기능을 점검 중입니다.
								</Text>
							</View>
						)}
					</View>
				) : (
					<>
						{tabs[id]?.header && <>{tabs[id]?.header}</>}

						<TableAPI
							title={tabs[id].title}
							apikey={tabs[id].apikey + data?.id}
							height={'default'}
							columns={tabs[id].columns}
							detail={tabs[id].detail}
							datesearch={tabs[id].datesearch}
							walletlist={tabs[id].walletlist}
							footer={tabs[id].footer}
							fold={fold}
							uid={data?.id}
						/>
					</>
				)}

				{tabs[id].title == '실시간' && (
					<>
						<TableWrapper>
							<TableAPI
								title={'미체결내역'}
								apikey={
									'/admin/history/orders?status=1&user_id=' +
									data?.id
								}
								height={250}
								columns={column_order}
								detail={
									'/record/transaction-details?userid=' + data?.id
								}
								datesearch={false}
								walletlist={false}
								footer={FOOTER.MARGINSUM}
								fold={fold}
								uid={data?.id}
							/>
						</TableWrapper>
						<TableWrapper>
							<TableAPI
								title={'계좌'}
								apikey={'/admin/walletlist?userid=' + data?.id}
								height={250}
								columns={column_walletlist}
								detail={false}
								datesearch={false}
								walletlist={false}
								footer={false}
								fold={fold}
								uid={data?.id}
							/>
						</TableWrapper>
					</>
				)}
			</>
		)
	}
	if (data?.id == undefined) return null

	return (
		<TabsContainer>
			<StyledTabs
				defaultActiveKey="1"
				tabPosition={'top'}
				onClick={e => {
					setLazy(false)
				}}
				destroyInactiveTabPane={lazy}
				items={new Array(tabs.length).fill(null).map((_, i) => {
					const id = String(i)
					return {
						label: `${tabs[i]?.title}`,
						key: id,
						disabled: i === 28,
						children: ChildrenComp(id),
					}
				})}
			/>
		</TabsContainer>
	)
}

export default React.memo(UserInfoTabs)

export const AdminDepositTableColumn: any = (mutate, openModal) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			align: 'center',
			width: 70,
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '구분',
			dataIndex: 'type',
			align: 'center',
			width: 100,
			render: (text, data) => <Text
				style={{
					color: text == 'D' ? COLORS.lightGreen : 'red',
				}}
			>{text == 'D' ? '입금' : '출금'}</Text>,
		},
		{
			title: '생성일',
			dataIndex: 'created_at',
			align: 'center',
			width: 130,
			render: (text, data) => <EntryTime time={text} offset={9} />,
		},
		{
			title: '승인일',
			dataIndex: 'confirm_at',
			width: 130,
			align: 'center',
			render: (text, data) => {
				{
					return text ? (
						<EntryTime time={text} offset={9} />
					) : (
						<Text>-</Text>
					)
				}
			},
		},
		{
			title: '진행',
			dataIndex: 'process',
			width: 80,
			align: 'center',
			render: (text, data) => (
				<TagWrap>
					{text == 1 ? (
						<Tag
							style={{
								backgroundColor: '#f79336',
								color: 'white',
							}}>
							대기
						</Tag>
					) : text == 2 ? (
						<Tag
							style={{
								backgroundColor: COLORS.lightGreen,
								color: 'white',
							}}>
							{data?.confirm_amount ? '지급완료' : '입금승인'}
						</Tag>
					) : text == 3 ? (
						<Tag
							style={{ backgroundColor: '#444', color: 'white' }}>
							검토중
						</Tag>
					) : text == 4 ? (
						<Tag style={{ color: 'red' }}>거절됨</Tag>
					) : (
						<Tag>취소</Tag>
					)}
				</TagWrap>
			),
		},
		{
			title: '요청금액',
			dataIndex: 'amount',
			align: 'center',
			sorter: (a, b) => a.amount - b.amount,
			render: (text, data) => <KrwPrice price={text || 0} dp={0} />,
		},
		{
			title: '입출금승인',
			dataIndex: 'confirm_amount',
			align: 'center',
			sorter: (a, b) => a.confirm_amount - b.confirm_amount,
			render: (text, data) => <KrwPrice price={text || 0} dp={0} />,
		},
		{
			title: '실명',
			align: 'center',
			dataIndex: 'name',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '비고',
			align: 'center',
			dataIndex: 'bankaccount',
			render: (text, data) => {
				return (
					<Tooltip title={text}>
						<Text
							style={{
								maxWidth: 250,
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
							}}>
							{text == 'undefined/undefined/undefined'
								? '-'
								: text}
						</Text>
					</Tooltip>
				)
			},
		},
	]
}
